import { before, after } from './bits'

import Emitter from './emitter'
import lightThrottle from './light-throttle'

import { offEvent, onEventPassive } from './on-event'

const IGNORE = [
  'TEXTAREA',
  'INPUT',
  'SELECT',
  'FORM'
]

export const keydownSpace  = Keydown(32)
export const keydownRight  = Keydown(39)
export const keydownLeft   = Keydown(37)
export const keydownDown   = Keydown(40)
export const keydownEsc    = Keydown(27)
export const keydownUp     = Keydown(38)
export const keydownF      = Keydown(70)
export const keydownH      = Keydown(72)
export const keydownShiftF = Keydown(70, { shiftKey: true })
export const keydownShiftH = Keydown(72, { shiftKey: true })

function Keydown(keyCode, { altKey = false, ctrlKey = false, metaKey = false, shiftKey = false } = {}) {
  const emitter = Emitter(`keydown[keyCode=${keyCode}]`)
  const throttleDelay = 100
  const throttledEmit = lightThrottle(emitter.emit, throttleDelay)

  emitter.on = before(beforeOn, emitter.on)
  emitter.pre = before(beforeOn, emitter.pre)
  emitter.after = before(beforeOn, emitter.after)
  emitter.off = after(emitter.off, afterOff)
  emitter.clear = after(emitter.clear, afterOff)

  return emitter

  function beforeOn() {
    if (emitter.size() === 0) {
      onEventPassive(window, 'keydown', keydownEventListener)
    }
  }

  function afterOff() {
    if (emitter.size() === 0) {
      offEvent(window, 'keydown', keydownEventListener)
    }
  }

  function keydownEventListener(event) {
    const expectedKeyCode = event.keyCode === keyCode
    const expectedNodeName = IGNORE.indexOf(event.target.nodeName) === -1
    const expectedModifiers = true
      && event.altKey === altKey
      && event.ctrlKey === ctrlKey
      && event.metaKey === metaKey
      && event.shiftKey === shiftKey

    const expectedEvent = true
      && expectedKeyCode
      && expectedNodeName
      && expectedModifiers

    if (expectedEvent) {
      throttledEmit(event)
    }
  }
}
